import React from 'react';
import { useUser } from '@clerk/clerk-react';
import SignInPrompt from '../../../components/SignInPrompt';
import NoAccessNotice from '../../../components/NoAccessNotice';
import { canUseChangeControl } from './changeControl';

export default function ChangeControlGuard({ children }) {
  const { user, isLoaded, isSignedIn } = useUser();
  if (!isLoaded) return <p role="status">Loading access…</p>;
  if (!isSignedIn) return <SignInPrompt pageName="Change Control" />;
  if (!canUseChangeControl(user)) return <NoAccessNotice pageName="Change Control" />;
  return children;
}
